import { render, staticRenderFns } from "./ProvisionDevicesAdmin.vue?vue&type=template&id=582c957b&scoped=true&"
import script from "./ProvisionDevicesAdmin.vue?vue&type=script&lang=js&"
export * from "./ProvisionDevicesAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582c957b",
  null
  
)

export default component.exports